import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Constants } from "../../constants/gsfCalc-constants";

@Injectable()
export class WasteReductionService {

  totalEstimatedSavings = 0;
  private tableConfigQus = {};

  constructor(private readonly  _http: HttpClient) {}

  loadWasteReductionData(langCode): void {
    this.loadOrganicWasteQusConfig().subscribe((config) => {
      this.tableConfigQus["W.6"] = config;
    });
    this.loadNonOrganicWasteQusConfig().subscribe((config2) => {
      this.tableConfigQus["W.5"] = config2;
    });
    this.getWasteReductionJsonData(langCode).subscribe(wasteConfigJson => {
      this.tableConfigQus["W.2"] = wasteConfigJson;
    });
  }
  public setTableConfigQus(config){
    this.tableConfigQus=config;
  }

  getWasteReductionJsonData(langCode): any {
    const filePath = "assets/waste-reduction-config-eng.json";
    return this._http.get(filePath);
  }

  private loadOrganicWasteQusConfig() {
    const filePath = "assets/waste-pillar-config/organicQus.json";
    return this._http.get(filePath);
  }

  private loadNonOrganicWasteQusConfig() {
    const filePath = "assets/waste-pillar-config/nonOrganicQus.json";
    return this._http.get(filePath);
  }

  public getTableConfigQus(qusId: string) {
    return this.tableConfigQus && this.tableConfigQus[qusId]
      ? this.tableConfigQus[qusId]
      : null;
  }

  getWasteRedActList(reportSubId, pillarId, tableId) {
    const activities = [];
    const wasteRedTypes = Object.keys(this.tableConfigQus[tableId]);
    wasteRedTypes.forEach(wasteRedType => {
      activities.push(
        this.getActivityDetails(
          this.tableConfigQus[tableId][wasteRedType],
          reportSubId,
          pillarId
        )
      );
    });
    return activities;
  }

  private getActivityDetails(wasteReduction, reportSubId, pillarId) {
    const activityDetails: any = {
      activityId: Constants.TEST,
      commonActivity: false
    };
    const questionDetails = this.getWasteRedQusDetails(
      wasteReduction,
      reportSubId,
      pillarId
    );
    const questionList = [questionDetails];
    activityDetails.questionList = questionList;

    return activityDetails;
  }

  private getWasteRedQusDetails(wasteReduction, reportSubId, pillarId) {
    const wasteRedQus: any = {
      reportSubmissionId: reportSubId,
      pillarId,
      reportId: null,
      gsfKPIName: wasteReduction.qusId,
      gsfKPIValue: wasteReduction.grandTotal,
      status: wasteReduction.status,
      commonActivity: false,
      GSFCalculation: {}
    };
    if (
      wasteReduction.status === Constants.UPDATE ||
      wasteReduction.status === Constants.DELETE
    ) {
      wasteRedQus.reportDetailGSFId = wasteReduction.reportDetailGSFId;
    }

    const gsfCalDetailsList = this.getWasteReductionInputList(wasteReduction);
    wasteRedQus.gsfCalDetailsList = gsfCalDetailsList;
    return wasteRedQus;
  }

  private getWasteReductionInputList(wasteReduction) {
    let wasteRedInputList = [];
    const materialTypes = Object.keys(wasteReduction.materialTypes);
    materialTypes.forEach(material => {
      const materialIpList = this.getMaterialInputList(
        wasteReduction.materialTypes[material]
      );
      wasteRedInputList = wasteRedInputList.concat(materialIpList);
    });

    return wasteRedInputList;
  }

  private getMaterialInputList(material) {
    const materialInputList = [];
    const categorys = Object.keys(material.category);
    categorys.forEach(category => {
      if (material.category[category].type !== Constants.LABEL) {
        materialInputList.push(
          this.getCategoryInput(material.category[category])
        );
      }
    });

    return materialInputList;
  }

  private getCategoryInput(category) {
    const input: any = {
      inputId: category.inputControlID,
      inputValue: category.value ? parseFloat(category.value) : 0,
      status: category.status ? category.status : Constants.CREATE
    };
    if (category.status && category.status === Constants.UPDATE) {
      input.reportGSFCalcDetailId = category.reportGSFCalcDetailId;
      input.reportDetailGSFId = category.reportDetailGSFId;
    }
    return input;
  }
}
